// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.Suppress
import org.mifos.mobile.core.model.entity.register.RegisterPayload
import org.mifos.mobile.core.model.entity.register.UserVerify

@OptIn(InternalKtorfitApi::class)
public class _RegistrationServiceImpl(
  private val _ktorfit: Ktorfit,
) : RegistrationService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override suspend fun registerUser(registerPayload: RegisterPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "registration")
        }
        setBody(registerPayload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun verifyUser(userVerify: UserVerify?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "registration/user")
        }
        setBody(userVerify) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }
}

public class _RegistrationServiceProvider : ClassProvider<RegistrationService> {
  override fun create(_ktorfit: Ktorfit): RegistrationService = _RegistrationServiceImpl(_ktorfit)
}

public fun Ktorfit.createRegistrationService(): RegistrationService = _RegistrationServiceImpl(this)
